import { FC, useState } from "react";
import { IoIosArrowDown, IoIosArrowUp  } from "react-icons/io";
import LandingIa from "../assets/images/landingia.jpg"

const AccordionItem = ({ title, content }: { title: string; content: string }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-300">
      <button
        className="w-full flex justify-between items-center py-3 text-left text-gray-800 font-semibold"
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        {isOpen ? <IoIosArrowUp size={20} /> : <IoIosArrowDown size={20} />}
      </button>
      {isOpen && <p className="text-gray-600 pb-3">{content}</p>}
    </div>
  );
};

const WhyChooseUs: FC = () => {
  return (
    <section className="w-[70%] mx-auto px-6 py-32">
      <h2 className="text-3xl font-bold text-center">Porque Elegirnos</h2>
      <p className="text-gray-700 text-center mt-4 leading-8">
      Elige Pixu y lleva el control total de tu servicio de transporte con precisión y eficiencia. Nuestra plataforma utiliza GPS e inteligencia artificial para registrar cada pasajero según su punto de subida y bajada, calculando tarifas justas y generando estadísticas detalladas por semana o mes. Con Pixu, optimizas tus ingresos, mejoras la gestión y tomas decisiones estratégicas basadas en datos reales. ¡Simplifica tu operación y haz crecer tu negocio con tecnología inteligente!
      </p>
      
      <div className="mt-10 flex flex-col md:flex-row items-center gap-16 justify-center">
        {/* Imagen */}
        <img 
          src={LandingIa}
          alt="Tecnología avanzada" 
          className="rounded-xl shadow-lg max-w-xl"
        />

        {/* Acordeón */}
        <div className="w-full max-w-lg">
          <AccordionItem title="Optimización de ingresos" content="Aumenta la rentabilidad con datos precisos y estrategias optimizadas." />
          <AccordionItem title="Precisión con GPS e IA" content="Nuestra tecnología avanzada registra con exactitud dónde suben y bajan los pasajeros, brindando datos confiables en tiempo real." />
          <AccordionItem title="Estadísticas detalladas" content="Obtén reportes semanales y mensuales con información clave para mejorar tu servicio." />
          <AccordionItem title="Mayor transparencia y control" content="Monitorea toda la operación con datos en tiempo real y toma decisiones estratégicas." />
          <AccordionItem title="Facilidad y flexibilidad" content="Una plataforma intuitiva y adaptable a tus necesidades." />
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
